import type { JSX } from "react";
import type { ChildrenProp } from "@charterindex/armoury-www";
import type { TranslationService } from "./translation-service";
import { I18nextProvider } from "react-i18next";


export type TranslationProviderProps = ChildrenProp & {
	translation: TranslationService;
};
export const TranslationProvider = ({ translation, children }: TranslationProviderProps): JSX.Element => (
	<I18nextProvider i18n={ translation.i18n }>
		{ children }
	</I18nextProvider>
);